import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["blockSize", "paddingBlock", "children", "isLoading"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "gap", "icon"],
  _excluded4 = ["children", "paddingBlockStart"],
  _excluded5 = ["children"],
  _excluded6 = ["alignItems", "children", "flex", "isVisible", "gap", "justifyContent"],
  _excluded7 = ["children", "gap"],
  _excluded8 = ["children"];
import { createContext, useContext } from 'react';
import { BodySmall, Button, Caption, Heading, IconContainer, LayoutBox, LayoutCard, LayoutHorizontal, LayoutSpaceVertical, Skeleton } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardSmartPropertyContext = /*#__PURE__*/createContext({
  isLoading: false
});
export const CardSmartProperty = _ref => {
  let {
      blockSize = '100%',
      paddingBlock = 'space',
      children,
      isLoading = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardSmartPropertyContext.Provider, {
    value: {
      isLoading
    },
    children: /*#__PURE__*/_jsx(LayoutCard, Object.assign({}, rest, {
      blockSize: blockSize,
      paddingBlock: paddingBlock,
      children: /*#__PURE__*/_jsx(LayoutSpaceVertical, {
        gap: "space-sm",
        children: children
      })
    }))
  });
};
const Icon = _ref2 => {
  let {
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(IconContainer, Object.assign({}, rest, {
    "data-test-id": "smart-property-card-icon",
    flex: "0 0 auto",
    variant: "disabled",
    children: children
  }));
};
const PropertyLabel = _ref3 => {
  let {
      children,
      gap = 'space-xxs',
      icon
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(Caption, {
    children: /*#__PURE__*/_jsxs(LayoutHorizontal, Object.assign({}, rest, {
      gap: gap,
      children: [/*#__PURE__*/_jsx(Icon, {
        children: icon
      }), children]
    }))
  });
};
const CardHeading = _ref4 => {
  let {
      children,
      paddingBlockStart = 'space-xxs'
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  const {
    isLoading
  } = useContext(CardSmartPropertyContext);
  return /*#__PURE__*/_jsx(LayoutBox, {
    inlineSize: "100%",
    paddingBlockStart: paddingBlockStart,
    children: /*#__PURE__*/_jsx(Skeleton, {
      blockSize: "1.375rem",
      inlineSize: "100%",
      isLoading: isLoading,
      maxInlineSize: "38ch",
      variant: "breeze",
      children: /*#__PURE__*/_jsx(Heading, Object.assign({}, rest, {
        as: "h6",
        children: /*#__PURE__*/_jsx(LayoutHorizontal, {
          flexWrap: "wrap",
          gap: "space-sm",
          children: children
        })
      }))
    })
  });
};
const Description = _ref5 => {
  let {
      children
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded5);
  return /*#__PURE__*/_jsx(BodySmall, Object.assign({}, rest, {
    children: children
  }));
};
const Header = _ref6 => {
  let {
      alignItems = 'top',
      children,
      flex = '1 1 auto',
      isVisible = true,
      gap = 'space',
      justifyContent = 'space-between'
    } = _ref6,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded6);
  if (!isVisible) return null;
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    alignItems: alignItems,
    flex: flex,
    gap: gap,
    justifyContent: justifyContent,
    children: children
  }));
};
const CardBody = _ref7 => {
  let {
      children,
      gap = 'space-xxs'
    } = _ref7,
    rest = _objectWithoutPropertiesLoose(_ref7, _excluded7);
  const {
    isLoading
  } = useContext(CardSmartPropertyContext);
  return /*#__PURE__*/_jsx(Skeleton, {
    blockSize: "2.5rem",
    inlineSize: "100%",
    isLoading: isLoading,
    variant: "breeze",
    children: /*#__PURE__*/_jsx(LayoutSpaceVertical, Object.assign({
      gap: gap
    }, rest, {
      children: children
    }))
  });
};
const CardButton = _ref8 => {
  let {
      children
    } = _ref8,
    rest = _objectWithoutPropertiesLoose(_ref8, _excluded8);
  const {
    isLoading
  } = useContext(CardSmartPropertyContext);
  return /*#__PURE__*/_jsx(LayoutBox, {
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      disabled: isLoading,
      size: "xs",
      variant: "tertiary-light"
    }, rest, {
      children: children
    }))
  });
};
CardSmartProperty.Icon = Icon;
CardSmartProperty.PropertyLabel = PropertyLabel;
CardSmartProperty.Heading = CardHeading;
CardSmartProperty.Description = Description;
CardSmartProperty.Header = Header;
CardSmartProperty.Body = CardBody;
CardSmartProperty.Button = CardButton;